(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !window.DesignMode) return;
  try {
    
  const faq = document.querySelectorAll("a.aside-section__title");
  const titles = document.querySelectorAll(".article-section__title");

  faq.forEach((f, id) => {
    if(id === 0){
      f.classList.add("active");
      titles[id].classList.add("active");
    }
    f.addEventListener("click", (evt) => setActive(evt, id))
  })

  function setActive(evt, id) {
    removeClass(faq);
    evt.target.classList.add("active");
    titles[id].classList.add("active");
  }

  function removeClass(list) {
    list.forEach((l, id) => {
      if (l.classList.contains("active")) {
        l.classList.remove("active");
      }
      const title = titles[id];
      if(title) {
        if (title.classList.contains("active")){
          title.classList.remove("active")
        }
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-features"]) return;
  try {
    
  const scroll_thumb_area = document.querySelector(".product-gallery__thumbnail-list");
  const thumb = document.querySelector(".product-gallery__thumbnail");
  const down_arrow = document.querySelector(".product-gallery__thumbnail-list-wrapper > button.down__icon");
  const up_arrow = document.querySelector(".product-gallery__thumbnail-list-wrapper > button.up__icon");

  down_arrow.addEventListener("click", scrollDown)
  up_arrow.addEventListener("click", scrollUp)


  function scrollDown() {
    scroll_thumb_area.scrollBy({
      top: 100,
      left: 0,
      behavior: "smooth",
    });
  }

  function scrollUp() {
    scroll_thumb_area.scrollBy({
      top: -100,
      left: 0,
      behavior: "smooth",
    });
  }

        console.log('Heloo feature ::>>');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-accordion"] && !window.DesignMode) return;
  try {
    
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    accordion.addEventListener("click", () => {
      accordions.forEach((accord) => {
        if (accord.ariaExpanded){
          accord.ariaExpanded = false;
          accord.removeAttribute("open");
        }
      })
      accordion.toggleAttribute("open", true);
      accordion.ariaExpanded = !JSON.parse(accordion.ariaExpanded);
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-kit-slider"] && !window.DesignMode) return;
  try {
    
  const carousel_items = document.querySelectorAll(".kit-slider__item");
  const indicators = document.querySelectorAll(".kit-slider__indicator");

  carousel_items.forEach((item, index) => {
    if(index == 0) {
      item.classList.add("is-selected");
    }
    item.addEventListener("click", (evt) => {
       carousel_items.forEach((indc) => {
          if(indc.classList.contains("is-selected")){
            indc.classList.remove("is-selected");
          }
       })
      item.classList.add("is-selected");
    })
  });

  indicators.forEach((indicator, index) => {
    indicator.addEventListener("click", (evt) => {
      carousel_items[index].classList.add("is-selected");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
